import { Profile, UserInfo } from '../types';

export const mockProfiles: Profile[] = [
    {
        id: '1',
        name: 'US GL Month June',
        lastUpdated: '2023-10-09T17:30:00Z',
        createdBy: 'akhamra',
        description: 'Monthly GL processing for US region',
        status: 'active'
    },
    {
        id: '2', 
        name: 'UK GL Close Month End',
        lastUpdated: '2023-10-09T17:30:00Z',
        createdBy: 'akhamra',
        description: 'UK month end close processing',
        status: 'active'
    },
    {
        id: '3',
        name: '[Shared] Testing profile',
        lastUpdated: '2023-10-09T17:30:00Z',
        createdBy: 'akhamra',
        description: 'Shared testing environment profile',
        status: 'processing'
    },
    {
        id: '4',
        name: '[Team] Testing Profile',
        lastUpdated: '2023-10-09T17:30:00Z',
        createdBy: 'akuanta',
        description: 'Team testing profile for development',
        status: 'active'
    },
    {
        id: '5',
        name: 'GL book end process',
        lastUpdated: '2023-10-09T17:30:00Z',
        createdBy: 'akhamra',
        description: 'General ledger book end processing',
        status: 'active'
    },
    {
        id: '6',
        name: 'Some more',
        lastUpdated: '2023-10-09T17:30:00Z',
        createdBy: 'akhamra',
        description: 'Additional profile for testing',
        status: 'inactive'
    }
];

export const mockUser: UserInfo = {
    username: 'akhanra',
    displayName: 'akhanra',
    avatar: undefined,
    preferences: {
        theme: 'light',
        locale: 'en-US'
    }
};